import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Navbar from "./components/NavBar";
import { Toaster } from "react-hot-toast";
import WelcomePage from "./pages/WelcomePage";
import LoginPage from "./pages/auth/Signin";
import NotFound from "./pages/Notfound";
import ProtectedRoute from "./components/ProtectedRoute";
import Signup from "./pages/auth/Signup";
import PlayerHub from "./pages/user/PlayerHub";
import UserProfile from "./pages/user/UserProfile";
import UserList from "./pages/admin/UserList";
import AccessDenied from "./pages/auth/AccessDenied";
import ForgotPassword from "./pages/auth/ForgotPassword";
import UserDetails from "./pages/admin/UserDetails";
import ResetPassword from "./pages/auth/ResetPassword";
import Footer from "./components/Footer";
import AboutPage from "./pages/AboutPage";
import CreateMatch from "./pages/CreateMatch";
import OAuth2RedirectHandler from "./pages/auth/OAuth2RedirectHandler";
import PongPage from "./pages/PongPage";
import LeaderboardPage from "./pages/LeaderboardPage";
import FriendsPage from "./pages/FriendsPage";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Toaster
        position="bottom-center"
        reverseOrder={false}
        toastOptions={{
          style: {
            background: "oklch(0.15 0.018 270)",
            color: "oklch(0.92 0.005 270)",
            border: "1px solid oklch(0.22 0.022 270)",
            fontSize: "0.875rem",
          },
        }}
      />
      <Routes>
        <Route path="/" element={<WelcomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-Password" element={<ForgotPassword />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />

        {/* <Route
          path="/match/:id"
          element={
            <ProtectedRoute>
              <MatchDetails />
            </ProtectedRoute>
          }
        /> */}
        <Route
          path="/playerhub"
          element={
            <ProtectedRoute>
              <PlayerHub />
            </ProtectedRoute>
          }
        />
        <Route
          path="/create-match"
          element={
            <ProtectedRoute>
              <CreateMatch />
            </ProtectedRoute>
          }
        />
        <Route
          path="/pong"
          element={
            <ProtectedRoute>
              <PongPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/leaderboard"
          element={
            <ProtectedRoute>
              <LeaderboardPage />
            </ProtectedRoute>
          }
        />

        <Route path="/access-denied" element={<AccessDenied />} />
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute adminPage={true}>
              <UserList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/friends"
          element={
            <ProtectedRoute>
              <FriendsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <UserProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/users/:userId"
          element={
            <ProtectedRoute adminPage={true}>
              <UserDetails />
            </ProtectedRoute>
          }
        />
        <Route path="/oauth2/callback" element={<OAuth2RedirectHandler />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
